import * as service from './login.service.js'

export default {

  data() {
    return {
      loginError: '',
      errorCount: '',
      errorStat: '',
      forgotMessage: '',
      testIn: '',
      testIn1: '',
      login: true,
      forgotPass: false,
      passClicked: false,
      forgotForm: {
        forgotuseremail: ''
      },
      loginForm: {
        useremail: '',
        userpassword: ''
      },
      rules: {
        useremail: [{
            required: true,
            message: 'This field is required',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Invalid Email Address',
            trigger: 'blur'
          },

        ],
        userpassword: [{
            required: true,
            message: 'This field is required'
          }

        ],
        forgotuseremail: [{
            required: true,
            message: 'This field is required',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Invalid Email Address',
            trigger: 'blur'
          },

        ],
      }

    }
  },

  mounted() {

  },

  methods: {
    submitForm(formName) { 

      this.loginError = ''
      let context = this
      this.$refs[formName].validate((valid) => {

        if (valid) {
          loader.startLoader()
          let loginData = 'grant_type=password&username=' + this.loginForm.useremail + '&password=' + this.loginForm.userpassword
          service.userLogin(loginData).then(function (response) {
            loader.stopLoader()
            $('.alert').show()
            localStorage.setItem('authentication', JSON.stringify(response))
            var auth = JSON.parse(localStorage.getItem('authentication'))
            if (auth) {
              if (auth.access_token) {
                if (auth.FirstName) {

                  window.authDetails = auth
                  window.userName = auth.FirstName + ' ' + auth.LastName

                  /********************************************************************************************
                  * FG - FOOF - After Cert - First Release (7) - First Release Security AND fix for pull in - BELOW
                  * ******************************************************************************************/
                  //A security "module" was created for the first release (feb 2021) 
                  //The line below sets the security rules upon a successful login
                  window.securityRules=JSON.parse(response.SecurityRules);

                  //NOTE: THERE ARE ALSO TWO VARIABLES IN THE RESPONSE THAT ARE NEW 
                  window.locationAtLogin=JSON.parse(response.Location);
                  window.poolsAtLogin=JSON.parse(response.Pools);
                  /********************************************************************************************
                  * FG - FOOF - After Cert - First Release (7) - First Release Security AND fix for pull in - ABOVE
                  * ******************************************************************************************/
                }
              }

              if (auth.ForceUpdatePassword == 'True') {
                let code = ''
                context.$router.push('/resetpassword?code=' + code + '&Username=' + auth.email)
              } else {

                if (!auth.FirstName && auth.role == 'AquaticsDirector') {
                  context.$router.push('/signupconfirm?OrganizationName=' + auth.OrganizationName)
                } else if (auth.userName == 'admin@hydro-ware.com') {
                  context.$router.push('/usermanagement')
                } else {
                  //FG - FOOF - After Cert - First Release Security (7) - this is a bit of a hack
                  //  to display the personell page rather than the dashboard page when the dashboard
                  //  is not available to the user that signed on.
                  //  I added the first if condition.. the check for IsFirstLogin had been there
                  if(context.$hydrowareSecurityJS.canDisplay_A(['incidents','chemicalrecord','activity'])==false)
                    context.$router.push('/UpdatePersonnel/' + authDetails.PersonnelId)
                  else 
                  if (authDetails.IsFirstLogin == "True") { 
                    context.$router.push('/UpdatePersonnel/' + authDetails.PersonnelId)
                  } else {
                    context.$router.push('/dashboard')
                  }

                }

              }

            }

          }).catch((error) => {
            loader.stopLoader()

            if (error.responseJSON.error_description.indexOf('password') > -1) {
              context.errorCount++
            }

            $('.alert').show()

            if (context.errorCount > 3) {
              context.loginError = error.responseJSON.error_description
            } else {
              context.loginError = error.responseJSON.error_description
            }

          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'LOGIN -1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    togglePassword() {

      if (!this.passClicked) {
        $('#password').children().attr('type', 'text')
        this.passClicked = true
      } else {
        $('#password').children().attr('type', 'password')
        this.passClicked = false
      }

    },
    forgotPassword() {

      this.forgotPass = true
      this.login = false
      this.loginForm = {}
      $('.alert').hide()
      this.$refs['loginForm'].resetFields()

    },
    backLogin() {
      this.forgotPass = false
      this.login = true
      this.forgotForm = {}
      this.$refs['forgotForm'].resetFields()
      $('.alert').hide()
    },
    alertClose() {
      $('.alert').hide()
    },

    hia() {
      //     alert('asd')
    },

    submitForgot(formName) {

      this.loginError = ''
      let context = this
      this.$refs[formName].validate((valid) => {

        if (valid) {
          loader.startLoader()

          service.forgotPassword(context.forgotForm.forgotuseremail).then(function (response) {
            loader.stopLoader()
            $('.alert').show()
            context.errorStat = true
            context.forgotMessage = 'We have sent a link to reset your password. If it\'s not in your inbox, please check your spam.'

          }).catch((error) => {
            $('.alert').show()
            loader.stopLoader()
            context.errorStat = false

            context.forgotMessage = error.responseJSON.Message
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'LOGIN - 2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.controller.js